import { useTranslation } from 'react-i18next';
import { EyeSlashIcon } from '@heroicons/react/24/outline';

import { MessageV2DTO, PartnerDTO } from 'support/types/dtos';
import { Page } from 'components/Page/Page';
import { Placeholder } from 'components/Placeholder/Placeholder';

import { ReviewBanner } from '../components/ReviewBanner/ReviewBanner';
import { MissingMessageSidebar } from './components/MissingMessageSidebar/MissingMessageSidebar';

type MissingMessageUIProps = {
  message: MessageV2DTO;
  relatedTransactions: Array<MessageV2DTO> | undefined;
  currentPartner: PartnerDTO;
};

export const MissingMessageUI = ({ message, relatedTransactions, currentPartner }: MissingMessageUIProps) => {
  const { t } = useTranslation();
  return (
    <Page isLoading={!message}>
      <Page.Head />
      <Page.Section
        rightAside={
          <MissingMessageSidebar
            message={message}
            relatedTransactions={relatedTransactions}
            currentPartner={currentPartner}
          />
        }
      >
        <div className="flex flex-col gap-6">
          <ReviewBanner message={message} />
          <Placeholder
            title={t('webedi:viewMessage.missingMessage.placeholder.title')}
            description={t('webedi:viewMessage.missingMessage.placeholder.description', {
              externalRef: message?.external_message_ref,
            })}
            icon={<EyeSlashIcon strokeWidth="1" />}
          />
        </div>
      </Page.Section>
    </Page>
  );
};
